

import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {Formik} from 'formik';
import * as yup from 'yup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import urls from "../../../utils/urls";
import placeholder from "../../../assets/images/placeholder-person.png";
import * as singleActions from "../../../store/actions/single";
import {NotificationManager} from "react-notifications";
import Select from '../../Common/Select';
import CategoryPicker from "../../Common/CategoryPicker";
import FormButtons from "../../Common/FormButtons";
import * as SingleActions from "../../../store/actions/single";





class DancerForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fileSelectField: '',
            filePickerOpen: false,
            selectingFileType: 'image',
            preview: '',
            image: '',
            disableNext: false,
            createSchool: '',
            createTeacher: ''
        }

        this.form = React.createRef();
    }

    handleFormModal = (e) => {
        this.setState({filePickerOpen: false})
    }

    selectFile = (file) => {
        //this.props.updateField('image', file);
        this.props.setValues({image: file});
    }



    schema = yup.object({
        name: yup.string().required(),
        lname: yup.string().required(),
        birthdate: yup.string().required(),
        grade: yup.object().shape({
            name: yup.string().required(),
            id: yup.string().required("Level is required"),
        }),
        region: yup.object().shape({
            _id: yup.string().required("Region is required"),
        }),
        school: yup.object().shape({
            _id: yup.string().required("School is required"),
        })
    });

    handleSubmit = (values) => {

        let data = new FormData();
        data.append("files", this.state.image);

        let params = {dancer: values};
        params.dancer.admins = [this.props.user.user._id];
        params.dancer.moderators = values.teacher ? [values.teacher._id] : [];
        params.dancer.region = values.region ? values.region._id : '';
        params.dancer.grade = values.grade ? values.grade.id ? values.grade.id : values.grade : '';
        params.dancer.school = values.school ? values.school._id : '';
        params.dancer.teacher = values.teacher ? values.teacher._id : '';
        if (params.dancer.teacher === ''){
            delete params.dancer.teacher;
        }

        if (params.dancer.region === ''){
            delete params.dancer.region;
        }

        if (this.props.match.params.id !== "new") {
            params.dancer._id = this.props.match.params.id;
        }

        if (this.state.createTeacher) {
            params.createTeacher = this.state.createTeacher;
        }

        if (this.state.createSchool) {
            params.createSchool = this.state.createSchool;
        }

        data.set("data", JSON.stringify(params));

        this.setState({disableNext: true});

        if (this.props.onboarding) {
            this.props.postOnboarding("users/nextStep", data, this.props.auth.token._id, (id) => {
                this.setState({disableNext: false});
            });
        } else {
            console.log("Redirecting", this.props.single.single._id)
            if (this.props.single.single._id) {
                this.props.patch("dancers", this.props.single.single._id, data, this.props.auth.token._id, (id) => {
                    this.props.history.push('/app/dancers/' + id);
                });
            } else {
                this.props.post("dancers", data, this.props.auth.token._id, (id) => {
                    console.log("Redirecting to dancer", id)
                    this.props.history.push('/app/dancers/' + id);
                });
            }
        }

    }

    componentDidMount(){
        this.props.loadOnboarding(this.props.auth.token._id);
        this.init();
    }

    componentDidUpdate(props, state) {
        if(props.single.single !== this.props.single.single) {
            this.init();
            if (this.form.current) {
                this.form.current.setValues({
                    ...this.props.single.single
                })
            }
            if (!this.props.onboarding) {
                if (props.match.params.id === 'new' && this.props.single.single._id) {
                    //this.props.history.push('/app/dancers/' + this.props.single.single._id)
                    //NotificationManager.success('Your changes have been saved');
                }
            }

        }


    }

    init = () => {

        if (this.props.single.single.image) {
            if (this.props.single.single.image.path) {
                this.setState({preview: urls.getS3Url(this.props.single.single.image.thumb || this.props.single.single.image.path)})
            }
        } else if (this.state.preview) {
            this.setState({preview: ''})

        }
    }

    //Grades (Beginner - Prizewinner), Championship, Adult
    grades = [
        {name: 'Grades (Non-Champion)', id: 'grades'},
        {name: 'Championship', id: 'championship'},
        {name: 'Adult', id: 'adult'},

    ];


    render() {

        let disableFields = false;

        if (this.props.location.pathname.indexOf('/dancers/') > -1 && this.props.match.params.id === 'new') {
            disableFields = false;
        } else {
            if (this.props.location.pathname.indexOf('/dancers/') > -1) {
                if (this.props.single.single) {
                    if (this.props.single.single.owners) {
                        if (this.props.single.single.owners.indexOf(this.props.user.user._id) === -1) {
                            disableFields = true;
                        }
                    }
                }
            }
        }

        return (
            <div className={"ex-pad"}>
                <Formik
                    validationSchema={this.schema}
                    onSubmit={this.handleSubmit}
                    enableReinitialize
                    ref={this.form}
                    initialValues={{
                        name: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? '' : this.props.single.single.name : this.props.single.dancer.name || '',
                        lname: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? '' : this.props.single.single.lname : this.props.single.dancer.lname || '',
                        image: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? '' : this.props.single.single.image : this.props.single.dancer.image || '',
                        birthdate: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? '' : this.props.single.single.birthdate ? new Date(this.props.single.single.birthdate).toISOString().split('T')[0] : '' :  this.props.single.dancer.birthdate ? new Date(this.props.single.dancer.birthdate).toISOString().split('T')[0] : '' || '',
                        grade: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? {} : this.grades.filter(g => g.id === this.props.single.single.grade)[0] : this.grades.filter(g => g.id === this.props.single.dancer.grade)[0] || {},
                        region: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? {} : this.props.single.single.region : this.props.single.dancer.region || {},
                        organization: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? '' : this.props.single.single.organization : this.props.single.dancer.organization || '',
                        school: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? {} : this.props.single.single.school : this.props.single.dancer.school || {},
                        teacher: this.props.location.pathname.indexOf('/dancers/') > -1 ? this.props.match.params.id === 'new' ? {} : this.props.single.single.teacher : this.props.single.dancer.teacher || {},
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                          isSubmitting,
                          setFieldValue
                      }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {this.props.onboarding ?
                                <FormButtons
                                    confirm={(e) => {
                                        handleSubmit(values);
                                    }}
                                    back={(e) => {
                                        e.preventDefault();
                                        this.step(values, "previous");
                                    }}
                                    showPrevious={false}
                                    showRevert={false}
                                    showNext={true}
                                    next={(e) => {
                                        e.preventDefault();
                                        handleSubmit(values);
                                    }}
                                    showDefault={false}
                                    label={'Dancer Profile'}

                                />
                                : null}

                            <Row>
                                <Col md={6} xs={12}>
                                    <div className={"field-container"}>
                                        <Form.Group controlId="image">
                                            {this.state.preview ?
                                                <div onClick={e => this.setState({filePickerOpen: true})} className={"artist-img avatar"} style={{background: this.state.preview ? `url(${this.state.preview}), linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.4), rgba(0,0,0,.2), transparent)` : `url(${placeholder}), linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.4), rgba(0,0,0,.2), transparent)`}}></div>
                                                //<img src={this.state.preview} className={"form-preview-image"} />
                                                :
                                                <div onClick={e => this.setState({filePickerOpen: true})} className={"artist-img avatar"} style={{background: `url(${placeholder}), linear-gradient(0deg, rgba(0,0,0,.6), rgba(0,0,0,.4), rgba(0,0,0,.2), transparent)`}}></div>

                                            }
                                            <Form.Control
                                                type="file"
                                                name="image"
                                                placeholder="Upload image"
                                                onChange={(e) => {
                                                    this.setState({
                                                        preview: URL.createObjectURL(e.target.files[0]),
                                                        image: e.target.files[0]
                                                    })
                                                }}
                                                disabled={disableFields}
                                                onBlur={handleBlur}
                                                isValid={touched.image && !errors.image}
                                                className={`form-control hidden-file-input ${touched.image ? errors.image ? 'is-invalid' : 'is-valid' : ''}`}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>
                                <Col md={6} xs={12}>


                                    <div className={""}>
                                        <Row>
                                            <Col md={12}>
                                                <div className={"field-container"}>
                                                    <Form.Group controlId="name">
                                                        <Form.Label>First Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            placeholder="Enter name"
                                                            value={values.name}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            disabled={disableFields}
                                                            isValid={touched.name && !errors.name}
                                                            className={`form-control ${touched.name ? errors.name ? 'is-invalid' : 'is-valid' : ''}`}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className={"field-container"}>
                                                    <Form.Group controlId="lname">
                                                        <Form.Label>Last Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="lname"
                                                            placeholder="Enter last name"
                                                            value={values.lname}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            disabled={disableFields}
                                                            isValid={touched.lname && !errors.lname}
                                                            className={`form-control ${touched.lname ? errors.lname ? 'is-invalid' : 'is-valid' : ''}`}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <div className={"field-container"}>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Label>Date of birth</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="birthdate"
                                                            placeholder="Birthdate (mm/dd/yyy)"
                                                            value={values.birthdate}
                                                            defaultValue={values.birthdate}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isValid={touched.birthdate && !errors.birthdate}
                                                            className={`form-control ${touched.birthdate ? errors.birthdate ? 'is-invalid' : 'is-valid' : ''}`}

                                                        />
                                                    </Form.Group>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className={"field-container"}>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Label>Level </Form.Label>
                                                        <Select
                                                            disableTyping={true}
                                                            items={this.grades}
                                                            value={values.grade || {}}
                                                            itemValue={"id"}
                                                            onChange={val => {
                                                                setFieldValue('grade', val);
                                                            }}
                                                            displayValue={"name"}

                                                        />

                                                        {errors.grade && touched.grade && (<p className={"text-danger hint-text"}>{errors.grade.id}</p>)}
                                                    </Form.Group>
                                                </div>
                                            </Col>

                                        </Row>

                                    </div>
                                </Col>
                            </Row>

                            <div className={"divider"} />

                            <Row>
                                <Col md={12}>
                                    <div className={"field-container"}>
                                        <label>School</label>

                                        <CategoryPicker
                                            items={this.props.single.schools}
                                            value={values.school || {}}
                                            itemValue={"_id"}
                                            onChange={val => setFieldValue('school', val)}
                                            remote={true}
                                            remoteKey={'schools'}
                                            urlRoute={"/search"}
                                            displayValue={"name"}
                                            imageKey={"image"}
                                            showDelete={false}
                                            onDelete={val => {
                                                setFieldValue('school', {})
                                            }}
                                            onType={e => {
                                                this.setState({createSchool: e.target.value})
                                            }}

                                        />
                                        {errors.school && touched.school && (<p className={"text-danger hint-text"}>{errors.school._id}</p>)}

                                    </div>
                                </Col>

                                <Col md={12}>
                                    <div className={"field-container"}>
                                        <label>Teacher Email Address</label>

                                        <CategoryPicker
                                            items={this.props.single.users}
                                            value={values.teacher || {}}
                                            itemValue={"_id"}
                                            onChange={val => setFieldValue('teacher', val)}
                                            remote={true}
                                            remoteKey={'users'}
                                            remoteQuery={{roles: 'teacher'}}
                                            remoteFields={['name', 'lname', 'email']}
                                            displayValue={"email"}
                                            imageKey={"image"}
                                            showDelete={false}
                                            onDelete={val => {
                                                setFieldValue('teacher', {})
                                            }}
                                            onType={e => {
                                                this.setState({createTeacher: e.target.value})
                                            }}

                                        />

                                    </div>
                                </Col>

                                <Col md={12}>
                                    <div className={"field-container"}>
                                        <label>Region</label>

                                        <Select

                                            disableTyping={true}
                                            items={this.props.single.regions}
                                            value={values.region || {}}
                                            itemValue={"_id"}
                                            onChange={val => {
                                                setFieldValue('region', val);
                                            }}
                                            displayValue={"name"}

                                        />
                                        {errors.region && touched.region && (<p className={"text-danger hint-text"}>{errors.region._id}</p>)}
                                    </div>
                                </Col>



                            </Row>
                            {!this.props.onboarding ?
                                <div>
                                    <div className={"divider"}/>
                                    <div className={"spacer"} />

                                    <Row>
                                        <Col md={12} className={"text-right"}>
                                            <Button variant="primary" onClick={e => handleSubmit(values)} disabled={this.state.submitting}>
                                                Submit
                                            </Button>
                                        </Col>
                                    </Row>
                                    <div className={"spacer"} />
                                </div>
                                : null}

                        </Form>
                    )}
                </Formik>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    single: state.single,
    user: state.user
});

const mapDispatchToProps = dispatch => ({
    postOnboarding: (view, data, token, redirect) => {
        dispatch(singleActions.postNextStep(view, data, token, true, redirect));
    },
    post: (view, data, token, redirect) => {
        dispatch(singleActions.postFormData(view, data, token, true, redirect, true));
    },
    patch: (view, id, data, token, cb) => {
        dispatch(singleActions.patchFormData(view, id, data, token, true, cb));
    },
    loadOnboarding: (token) => {
        dispatch(SingleActions.loadOnboardingNoSingle(token));
    }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(DancerForm));

class DancerFormContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default DancerFormContainer;
